import React, { useMemo, useState } from "react";
import { Box, Card, CardContent, CardHeader, Divider, Link, List, ListItem, ListItemText, Tab, Tabs, Typography } from "@mui/material";

function formatDateTime(value) {
    if (!value) return "—";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

export default function WorkspaceCard({ notes, uploads }) {
    const [tab, setTab] = useState(0);
    const noteItems = useMemo(() => notes || [], [notes]);
    const fileItems = useMemo(() => uploads || [], [uploads]);

    return (
        <Card variant="outlined" sx={{ minHeight: { xs: "auto", md: 520 }, display: "flex", flexDirection: "column", minWidth: 0 }}>
            <CardHeader
                title="Workspace"
                action={
                    <Tabs value={tab} onChange={(_, next) => setTab(next)} sx={{ minHeight: 36 }}>
                        <Tab label="Notes" sx={{ minHeight: 36 }} />
                        <Tab label="Files" sx={{ minHeight: 36 }} />
                    </Tabs>
                }
            />
            <Divider />
            <CardContent sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
                {tab === 0 ? (
                    noteItems.length === 0 ? (
                        <Typography variant="body2" color="text.secondary">No notes added yet.</Typography>
                    ) : (
                        <List dense disablePadding>
                            {noteItems.map((note) => (
                                <ListItem key={note.id} disableGutters sx={{ py: 1.25, borderBottom: "1px solid", borderColor: "divider" }}>
                                    <ListItemText
                                        primary={note.title || "Untitled note"}
                                        secondary={
                                            <Box sx={{ mt: 0.25 }}>
                                                <Typography component="div" variant="caption" color="text.secondary" sx={{ mb: 0.5 }}>
                                                    Created: {formatDateTime(note.created_at)}
                                                </Typography>
                                                <Typography component="div" variant="body2" color="text.secondary">
                                                    {note.content ? note.content.replace(/<[^>]+>/g, "") : "—"}
                                                </Typography>
                                            </Box>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>
                    )
                ) : fileItems.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">No uploaded files yet.</Typography>
                ) : (
                    <List dense disablePadding>
                        {fileItems.map((file) => (
                            <ListItem key={file.id} disableGutters sx={{ py: 1.25, borderBottom: "1px solid", borderColor: "divider" }}>
                                <ListItemText
                                    primary={
                                        <Link href={file.file_url} target="_blank" rel="noopener" underline="hover">
                                            {file.original_name}
                                        </Link>
                                    }
                                    secondary={`Created: ${formatDateTime(file.created_at)}${file.size_kb ? ` • ${file.size_kb} KB` : ""}`}
                                />
                            </ListItem>
                        ))}
                    </List>
                )}
            </CardContent>
        </Card>
    );
}

